import { Api, ApiUrl } from "../../services";
import { mutations as MUTATION, actions as ACTION } from "./types";

const actions = {
  [ACTION.SHOW_NOTIBAR]: async store => {
    const { state } = store;
    try {
      state.notiBar.isOpen = !state.notiBar.isOpen;
      state.notiBar.noti_list_unread = 0;
    } catch (error) {
      state.notiBar.isOpen = false;
    }
  },
  [ACTION.CLOSE_NOTIBAR]: async store => {
    const { state } = store;
    try {
      state.notiBar.isOpen = false;
    } catch (error) {
      state.notiBar.isOpen = false;
    }
  },
  [ACTION.TOOGLE_STICKY]: async store => {
    const { state } = store;
    try {
      state.sticky.dissMissed = !state.sticky.dissMissed;
    } catch (error) {
      state.sticky.dissMissed = !state.sticky.dissMissed;
    }
  },
  [ACTION.CLOSE_STICKY_MODAL]: async store => {
    const { state } = store;
    try {
      state.sticky.dissMissed = true;
      state.sticky.firstTime = false;
    } catch (error) {
      state.sticky.dissMissed = true;
      state.sticky.firstTime = false;
    }
  },
  [ACTION.TOOGLE_STICKY_FIRST_TIME]: async store => {
    const { state } = store;
    try {
      if (state.sticky.firstTime) {
        state.sticky.dissMissed = true;
        state.sticky.firstTime = false;
      }
    } catch (error) {
      state.sticky.dissMissed = true;
      state.sticky.firstTime = false;
    }
  },
  [ACTION.LOAD_NOTI]: async (store, { onSuccess, onError }) => {
    const { state } = store;
    try {
      state.notiBar.status.loadingNoti = true;
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      const res = await Api.base.get(ApiUrl.base.notification.noti_list);
      if (res && res.status) {
        state.notiBar.pinnedNoti = res.data.noti_list_pinned;
        state.notiBar.noti = res.data.noti_list;
        state.notiBar.noti_list_count = res.data.noti_list_count;
        state.notiBar.noti_list_unread = res.data.noti_list_unread;
        state.notiBar.last_system_noti = res.data.last_sys_noti;
        state.notiBar.limit_pagination = res.data.limit_pagination;
        if (state.notiBar.noti_list_unread > 0){
          state.notiBar.maxAllReaded = false
        }
        if (onSuccess && typeof onSuccess == "function") {
          onSuccess();
        }
      }
      state.notiBar.status.loadingNoti = false;

    
    } catch (error) {
      state.notiBar.status.loadingNoti = false;
      if (onError && typeof onError == "function") {
        onError(error);
      }
    }
  },
  [ACTION.TRACK_ACTION]: async (store, noti) => {
    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    if (noti.state == 0) {
      store.commit(MUTATION.TRACK_READ, noti);
    }
    store.commit(MUTATION.TRACK_ACTION, noti);
    await Api.base[method](ApiUrl.base.notification.action(noti.id));
  },
  [ACTION.SHOW_MODAL_NOTI]: async (store, noti) => {
    const { state } = store;
    state.notiBar.action.isViewingNoti = true;
    state.notiBar.action.noti = noti;
  },
  [ACTION.OPEN_NOTI_CONTENT]: async (store, noti) => {
    const { state } = store;
    state.notiBar.action.isViewingNotiContent = true;
    state.notiBar.action.noti = noti;
  },
  [ACTION.CLOSE_NOTI_CONTENT]: async (store) => {
    const { state } = store;
    state.notiBar.action.isViewingNotiContent = false;
  },
  [ACTION.CLOSE_MODAL_NOTI]: async (store) => {
    const { state, rootState } = store;
    state.notiBar.action.isViewingNoti = false;
    rootState.account.isModalPopup = false;
  },
  [ACTION.DISMISS_STICKY_NOTI]: async (store, { onSuccess, onError }) => {
    const { state } = store;
    store.commit(MUTATION.PINNED_SUCCESS, state.notiBar.last_system_noti[0]);
    if (state.notiBar.last_system_noti[0].is_important) {
      try {
        let method = process.env.NODE_ENV == "development" ? "get" : "post";
        let id = state.notiBar.last_system_noti[0].id;
        if (process.env.NODE_ENV == "development") {
          let delay = new Promise(resolve => {
            setTimeout(() => {
              resolve();
            }, 1500);
          });
          await delay;
        }
        let res = await Api.base[method](ApiUrl.base.notification.pin(id));

        if (res.data.status == false) {
          throw res.data.message;
        }
        if (onSuccess && typeof onSuccess == "function") {
          onSuccess();
        }
      } catch (error) {
        onError(error)
      }
    }
  },
  [ACTION.PIN_NOTI]: async (store, noti) => {
    const { state } = store;
    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    try {
      state.notiBar.status.loadingNoti = true;
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      const res = await Api.base[method](ApiUrl.base.notification.pin(noti.id));
      if (res && res.status) {
        // state.notiBar.noti = res.data.noti_list;
      }
      state.notiBar.status.loadingNoti = false;
    } catch (error) {
      state.notiBar.status.loadingNoti = false;
    }
  },
  [ACTION.PIN_NOTI_2]: async (store, { noti, onLoading, onSuccess, onError }) => {
    try {
      onLoading();
      let method = process.env.NODE_ENV == "development" ? "get" : "post";
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      let res = await Api.base[method](ApiUrl.base.notification.pin(noti.id));

      if (res.data.status == false) {
        throw res.data.message;
      }
      store.commit(MUTATION.PINNED_SUCCESS, noti);
      if (onSuccess && typeof onSuccess == "function") {
        onSuccess(res);
      }
    } catch (error) {
      if (onError && typeof onError == "function") {
        onError(error);
      }
    }
  },
  [ACTION.UNPIN_NOTI]: async (store, { noti, onLoading, onSuccess, onError }) => {
    try {
      onLoading();
      let method = process.env.NODE_ENV == "development" ? "get" : "post";
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      let res = await Api.base[method](ApiUrl.base.notification.unpin(noti.id));

      if (res.data.status == false) {
        throw res.data.message;
      }
      store.commit(MUTATION.UNPINNED_SUCCESS, noti);
      if (onSuccess && typeof onSuccess == "function") {
        onSuccess(res);
      }
    } catch (error) {
      if (onError && typeof onError == "function") {
        onError(error);
      }
    }
  },
  [ACTION.LOAD_MORE_NOTI]: async (store, { loaded, onSuccess, onError }) => {
    const { state } = store;
    try {
      state.notiBar.status.loadingMoreNoti = true;

      // let method = process.env.NODE_ENV == "development" ? "get" : "post";
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      let res = await Api.base['get'](ApiUrl.base.notification.noti_list_load(loaded));

      if (res.data.status == false) {
        state.notiBar.status.loadingMoreNoti = false;
        throw res.data.message;
      }
      store.commit(MUTATION.LOAD_MORE_NOTI, res.data.noti_list);
      if (onSuccess && typeof onSuccess == "function") {
        state.notiBar.status.loadingMoreNoti = false;
        onSuccess(res);
      }
    } catch (error) {
      if (onError && typeof onError == "function") {
        state.notiBar.status.loadingMoreNoti = false;
        onError(error);
      }
    }
  },
  [ACTION.MARK_ALL_READ]: async (store,{ onLoading,onSuccess, onError}) => {
    onLoading();
    const {state} = store

    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    try {
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          },1500)
        })
        await delay;
      }
      const res = await Api.base[method](ApiUrl.base.notification.markAllRead)
      if (res && res.data.status){
        if ( onSuccess && typeof onSuccess == "function" ){
          store.commit(MUTATION.MARK_ALL_READ);
          onSuccess()
        }
      }
      if (res.data.status == false){
        state.notiBar.status.loadingNoti = false;
        throw(res.data.message)
      }
    } catch (error) {
      if ( onError && typeof onError == "function" ){
        onError(error)
      }
    }
  }
};

export default actions;
